import { uploadData } from '@aws-amplify/storage';
import { fetchAuthSession } from 'aws-amplify/auth';

export interface UploadedErrorLogImages {
  errorLogId: string;
  identityId: string;
  keys: string[];
}

/**
 * Uploads error-report screenshots to the reporter's private S3 folder and returns the
 * generated errorLogId (caller passes it as the ErrorLog record id so keys stay in sync),
 * the reporter's Cognito identity id, and the full S3 keys.
 *
 * Path: private/{identityId}/errorLogs/{errorLogId}/{filename}
 * Admin group roles can read these objects directly (see userPoolGroups CFN).
 */
export async function uploadErrorLogImages(
  files: File[]
): Promise<UploadedErrorLogImages> {
  const errorLogId = crypto.randomUUID();
  const { identityId } = await fetchAuthSession();
  if (!identityId) {
    throw new Error('Unable to get Cognito Identity ID for error-log image upload.');
  }

  const keys: string[] = [];
  for (const file of files) {
    const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const key = `private/${identityId}/errorLogs/${errorLogId}/${safeName}`;
    await uploadData({
      path: key,
      data: file,
      options: { contentType: file.type || 'application/octet-stream' },
    }).result;
    keys.push(key);
  }

  return { errorLogId, identityId, keys };
}
